// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3RqXU","name":"ConsentHeader_name__2WAKk","birthday":"ConsentHeader_birthday__171Fy","skeleton":"ConsentHeader_skeleton__22ku1"};